import { ValidationError } from './validation-error'

export interface BatchResultInterface {
  succeed: number
  failed: number
  errors?: ValidationError[]
}

export class BatchResult implements BatchResultInterface {
  succeed: number
  failed: number
  errors?: ValidationError[]

  constructor(props: BatchResultInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      succeed: _succeed,
      failed: _failed,
      errors: _errors,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.succeed = _succeed
    this.failed = _failed
    this.errors = _errors ? _errors.map((i) => new ValidationError(i)) : _errors
  }
}
